<template>
  <v-dialog
    :modelValue="dialog"
    width="500"
    persistent
    contentClass="show-promo-details-actions"
    @update:modelValue="v => (v ? show() : close())"
  >
    <v-card flat>
      <v-card-title>Assign Custom Devices</v-card-title>
      <v-card-text>
        <div>
          These changes will only affect current prompt. You can configure custom devices
          <router-link :to="`/apps/${appId}/settings/custom_devices`">in settings</router-link>.
        </div>
        <RfSelect
          v-model="currPathCustomDevicesLocal"
          variant="outlined"
          autocomplete
          density="compact"
          chips
          :itemDisabled="
            ({ id }) =>
              currPathCustomDevicesLocal.find(v => v === id) &&
              currPathCustomDevicesLocal.length <= 1
          "
          multiple
          :items="customDevicesStore.customDevices"
          itemValue="id"
          itemTitle="name"
          data-cy="custom-device-modal--select"
          class="mt-5"
          mandatory
          title="Custom Devices"
          placeholder="Select custom devices"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn size="large" variant="outlined" class="cancel-btn" width="100px" @click="close">
          Close
        </v-btn>
        <RfButton
          size="large"
          icon="md:save"
          buttonText="Save"
          data-cy="custom-device-modal--submit"
          :disabled="!isCustomDevicesEdited"
          width="200px"
          color="primary"
          @click="submitDevices"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RfSelect from "@/components/legacy/RfSelectLegacy.vue";
import RfButton from "@/components/buttons/RfButton.vue";
import { cloneDeep } from "lodash-es";
import { useToastsStore } from "@/pinia/toastsStore";
import { useCustomDevicesStore } from "@/pinia/customDevicesStore";
import { usePromptStore } from "@/pinia/promptStore";

export default {
  name: "RfCustomDevicesModal",
  components: { RfSelect, RfButton },
  setup: () => ({
    toastsStore: useToastsStore(),
    promptStore: usePromptStore(),
    customDevicesStore: useCustomDevicesStore(),
  }),
  data: () => ({ dialog: false, currPathCustomDevicesLocal: [] }),
  computed: {
    isCustomDevicesEdited() {
      return (
        this.promptStore.customDevices.length !== this.currPathCustomDevicesLocal.length ||
        !this.promptStore.customDevices.every(el =>
          this.currPathCustomDevicesLocal.find(id => id === el.id),
        )
      );
    },
    appId() {
      return this.$route.params.aid;
    },
  },
  methods: {
    async show() {
      this.dialog = true;
      await this.customDevicesStore.getCustomDevices(this.appId);
      this.currPathCustomDevicesLocal = [...this.promptStore.customDevices];
    },
    close() {
      this.dialog = false;
      this.currPathCustomDevicesLocal = [];
    },
    async submitDevices() {
      try {
        const modelPath = cloneDeep(this.promptStore.prompt);
        modelPath.custom_devices = this.currPathCustomDevicesLocal.map(id => ({ id }));
        await this.promptStore.updatePrompt({
          appId: this.appId,
          pathId: modelPath.id,
          modelPath,
        });
        this.close();
      } catch (e) {
        this.toastsStore.create({ type: "error", body: e.message });
      }
    },
  },
};
</script>
